


















































































































import Vue from 'vue'
import BorderBtn from '@/components/border-button.vue'
import Notice from '@/components/notice.vue'
export default Vue.extend({
  components: {
    'border-btn': BorderBtn,
    Notice
  }
})
